import type React from 'react'
import { useEffect, useRef, useState } from 'react'
import { useClickAway } from 'react-use'

import { assert } from '@/helpers'
import css from './styles.module.css'

interface Props {
  onSubmit: (email: string) => void
}

export const EmailInput: React.FC<Props> = ({ onSubmit }) => {
  const [value, setValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)
  const inputWrapperRef = useRef<HTMLDivElement>(null)
  const [showError, setShowError] = useState(false)
  const [showInput, setShowInput] = useState(false)

  useClickAway(inputWrapperRef, () => {
    if (inputRef.current && inputRef.current.value.length === 0) {
      setShowInput(false)
      setShowError(false)
    }
  })

  useEffect(() => {
    if (showInput && inputRef.current) {
      inputRef.current.focus()
    }
  }, [showInput])

  const handleInvite = async () => {
    if (assert.emailAddress(value)) {
      showError && setShowError(false)

      onSubmit(value)
      setValue('')
    } else {
      !showError && setShowError(true)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleInvite()
    }
  }

  return (
    <div className={css.invite}>
      {!showInput && (
        <div
          className={css.invite_placeholder}
          onClick={() => {
            setShowInput(true)
          }}
        >
          Invite by email
        </div>
      )}

      {showInput && (
        <div ref={inputWrapperRef} className={css.invite_input}>
          <input
            type="text"
            ref={inputRef}
            value={value}
            onKeyDown={handleKeyDown}
            onChange={(e) => setValue(e.target.value)}
          />

          <button
            type="button"
            className={css.invite_button}
            onClick={handleInvite}
          >
            Invite
          </button>
        </div>
      )}

      {showError && (
        <div className={css.invite_error}>Please check email format</div>
      )}
    </div>
  )
}
